import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>Pre-Workout: wat is het en wat doet het precies?</title>
                <link rel="canonical" href={route("blogs.twenty-four")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Je hoort het misschien weleens voorbij komen; andere sporters die gebruik maken van pre-workout. De voornaamste reden voor het gebruiken van pre-workout is het bevorderen van de trainingen. Maar wat doet pre-workout nou precies en waarom zou je het wel of niet kunnen gebruiken?"
                />
                <meta
                    property="og:description"
                    content="Je hoort het misschien weleens voorbij komen; andere sporters die gebruik maken van pre-workout. De voornaamste reden voor het gebruiken van pre-workout is het bevorderen van de trainingen. Maar wat doet pre-workout nou precies en waarom zou je het wel of niet kunnen gebruiken?"
                />
                <meta property="og:url" content={route("blogs.twenty-four")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Pre-Workout: wat is het en wat doet het precies? - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/blog/pre-workout.jpeg"
                />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh] pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/pre-workout.webp"
                                    type="image/webp"
                                    alt="Pre-workout"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/pre-workout.jpg"
                                    type="image/jpeg"
                                    alt="Pre-workout"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/pre-workout.jpg"
                                    alt="Pre-workout"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Pre-Workout: wat is het en wat doet het precies?
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        Je hoort het misschien weleens voorbij komen; andere
                        sporters die gebruik maken van pre-workout. De
                        voornaamste reden voor het gebruiken van pre-workout is
                        het bevorderen van de trainingen. Maar wat doet
                        pre-workout nou precies en waarom zou je het wel of niet
                        kunnen gebruiken?
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Wat is pre-workout?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Pre-workout is supplement. Dit wil zeggen dat het een
                        toevoeging is die jij aan jou voedingsschema zou kunnen
                        toevoegen. Eigenlijk is pre-workout een combinatie van
                        verschillende supplementen die je ook los zou kunnen
                        gebruiken. Ook pre-workout zitten onder andere cafeïne,
                        vitamine B, beta alanine, L-citrulline, creatine en
                        L-glutamine. Deze stoffen hebben ieder een eigen
                        werking.
                    </p>
                    {/* -- */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-xl sm:text-xl">
                        Cafeïne
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        Cafeïne is natuurlijk bekend van onder andere koffie.
                        Cafeïne verbetert de spierkracht en uithoudingsvermogen.
                        Dit houdt in dat je jezelf verder en dieper kunt pushen
                        tijdens het trainen. Er zijn 2 manieren waarop dit
                        gebeurd. Ten eerste zorgt cafeïne ervoor dat je
                        bloedvaten uitzetten, waardoor er meer bloed naar je
                        spieren stroomt.
                    </p>
                    {/* -- */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-xl sm:text-xl">
                        Vitamine B
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        Er zitten verschillende b-vitamines in pre-workout. De
                        belangrijkste is vitamine B12, die de aanmaak van rode
                        bloedcellen stimuleert. Vitamine B12 helpt hiermee bij
                        het vervoeren van zuurstof in je bloed.
                    </p>
                    {/* -- */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-xl sm:text-xl">
                        Beta alanine
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        Beta alanine is een niet-essentieel aminozuur. Dat
                        betekent dat het lichaam dit zelf kan aanmaken. Samen
                        met L-histidine wordt carnosine gevormd. Carnosine
                        neutraliseert het melkzuur in de spieren. Dit betekent
                        dat de verzuring in de spieren minder zal zijn en je de
                        inspanning langer kunt volhouden.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Misschien heb je weleens gehoord en ervaren dat je jeuk
                        of tintelingen kan krijgen van pre-workout. Dit komt
                        door de Beta alanine. Als je hier last van hebt is het
                        aan te raden om te kijken naar een pre-workout met een
                        lagere hoeveelheid Beta alanine.
                    </p>
                    {/* -- */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-xl sm:text-xl">
                        L-citrulline
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        In pre-workout zit ook L-citrulline. Dit wordt in het
                        lichaam omgezet naar L-arginine. L-arginine heeft als
                        werking het verhogen van het stikstofoxide-gehalte in je
                        bloed. Hierdoor treedt er een verwijding van de
                        bloedvaten op. Dit stimuleert het transport van
                        voedingsstoffen en zuurstof richting de spieren.
                    </p>
                    {/* -- */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-xl sm:text-xl">
                        Creatine
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        Creatine is een lichaamseigen stof. Iedereen heeft
                        creatine in zijn lichaam in kleinere hoeveelheden. Dit
                        wordt aangemaakt in je nieren en lever. Dit gaat om
                        ongeveer 1 gram per dag. Dit wordt getransporteerd naar
                        de spieren waar het als energiebron dient. Via suppletie
                        kun je extra creatine toevoegen. Adenosine trifosfaat
                        wordt omgezet naar adenosine di fosfaat waarbij energie
                        vrijkomt:
                    </p>
                    <p className="mt-4 text-gray-100 text-lg font-bold">
                        ATP &harr; + ADP + P + Energie
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Na een intensieve inspanning moet ATP weer worden
                        aangevuld. Creatine versnelt dit proces waardoor je
                        sneller herstelt tijdens oefeningen en je meer energie
                        hebt tijdens het trainen.
                    </p>
                    {/* -- */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-xl sm:text-xl">
                        L-Glatumine
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        L-glutamine is een lichaamseigen aminozuur dat een
                        aantal processen in het lichaam regelt. Een proces in
                        een optimaal functionerend immuunsysteem. Daarnaast
                        stimuleert het anabolisme. Anabolisme is het opbouwen
                        van je spieren, oftewel spiergroei. Ook Glutamine kun je
                        via suppletie verhogen. Ook stimuleert L-Glutamine het
                        vervoer van stikstof naar je spieren en de afvoer van
                        ammoniak, wat een schadelijke stof voor het lichaam is.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Nadelen Pre-workout
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Er zitten ook wel een aantal mogelijke nadelen aan
                        pre-workout. Zo kan een hoge hoeveelheid cafeïne leiden
                        tot hartkloppingen, misselijkheid of hoofdpijn.
                        Daarnaast kan dit ook slaapproblemen veroorzaken. Neem
                        pre-workout niet laat in de avond, en als je dit wel
                        wilt doen probeer dan een cafeïnevrije pre-workout.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Daarnaast kun je merken dat je drukker of onrustiger
                        wordt als je pre-workout op hebt. Let er op dat
                        pre-workout gevoelens kan versterken in je gedachten, en
                        daarmee ook negatieve gevoelens. Als je depressieve
                        klachten ervaart zul je hier rekening mee moeten houden.
                        Als je merkt dat je negatieve gedachtes toenemen als de
                        pre-workout in werking is, probeer dan te trainen zonder
                        pre-workout.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Wanneer moet je pre-workout pakken?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Pre-workout zorgt er op verschillende manieren voor dat
                        je trainings prestaties kunnen verbeteren. Dit komt door
                        een toename van kracht, energie en
                        spieruithoudingsvermogen. Dit wil niet zeggen dat je het
                        zomaar moet nemen. Bouw dit altijd op in rustige
                        hoeveelheden. Begin met een halve scoop (max 7 gram) en
                        als je hiervan weinig effecten merkt kun je later
                        verhogen naar een hele scoop.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Optimaal gezien nuttig je pre-workout een half uur voor
                        de training. Het duurt namelijk even voordat je de
                        effecten kunt merken. Daarnaast is het het beste om
                        pre-workout gemengd met water in te nemen en niet te
                        droog scheppen. Dit kent een aantal gevaren, zoals
                        mogelijke hartritmestoornissen hebben Amerikaanse
                        onderzoekers ontdekt. Pak dus altijd een glas met water
                        of shakebeker en meng de pre-workout met het water
                        alvorens je dit opdrinkt.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Conclusie
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Pre-workout is dus een combinatie van verschillende
                        supplementen die jouw training prestaties kunnen
                        bevorderen. Hierin kan het voor velen een toevoeging
                        zijn, maar het is zeker geen must. Als je het een keer
                        wilt proberen, begin dan in kleine hoeveelheden. Zo kun
                        je zelf ervaren of pre-workout voor jou helpt of niet.
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
